const minin = {
  data() {
    return {
      baseUrl: 'order',
      formInline: {
        order_type: 2,
        ischeck: 1,
        // isstatus: 1,
      },
    };
  },
  methods: {
    onReset() {
      console.log("contract order onReset");
      // console.log(this.$refs)
      // 重置复合搜索框组件
      const comFormCtrl = this.$refs['comFormCtrl']
      comFormCtrl && comFormCtrl.reset()
      // 重置复合下拉框组件
      const comFormSelect = this.$refs['comFormSelect']
      comFormSelect && comFormSelect.reset()
      // 重置复合日期搜索框组件
      const comFormDate = this.$refs['comFormDate']
      comFormDate && comFormDate.reset()
      // 为所有字段设置undefined初始值
      const { ischeck } = this.formInline
      const obj = {
        order_type: 2,
        ischeck,
      }
      const { id } = this.$route.query
      if (id) {
        obj.contractid = id
      }
      this.baseParams.map(v => {
        obj[v] = this.formInline[v]
      })
      this.formCtrl.map(v => {
        obj[v.keyName] = undefined
      })
      this.searchKeyOptions.map(v => {
        obj[v.value] = undefined
      })
      // console.log(obj)
      this.formInline = obj;
      // 清除储存的搜索条件
      const path = this.$route.path
      this.setStore({
        ['formInline' + path]: obj,
      })
      // 回到首页
      this.page = 1;
      // 请求
      this.getList();
    },
    showPosition({ license, is_gps }) {
      if (is_gps != 1) {
        this.$message({
          type: 'error',
          message: '未绑定定位设备!'
        });
        return;
      }
      console.log(license)
      this.$router.push(`/order/contractposition?license=${license}`)
    },
  },
  created() {
    const { id } = this.$route.query
    // console.log('created contractid', id)
    if (id) {
      // 如果页面带id参数，说明是合同跳转过来的，搜索时加上合同id，同时搜索参数去掉客户名称，只保留车牌号
      this.formInline.contractid = id
      // this.searchKeyOptions = [
      //   { label: '车牌号', value: 'license', },
      // ]
      if (this.$route.path.includes('/own/')) {
        this.formCtrl.push({
          ...this.ctrls.license,
        })
      }
      this.$forceUpdate()
      // console.log('formInline', { ...this.formInline })
    }
  },
  mounted() { },
}

export default minin